import './index.css'

export default function Avatar({ src }){

    return (
        <div className="avatar">
            <img src={src} />
        </div>
    )
}